import { OrganizationTableItem } from 'types/organizations_table'

export const addChannelsToDeal = (deal: OrganizationTableItem, relatedProducts: OrganizationTableItem[]) => {
  const linkedIn = relatedProducts?.some(p => p?.productName?.includes('Linkedin Advertising'))
  const meta = relatedProducts?.some(p => p?.productName?.includes('Meta Advertising'))
  const simplifi = relatedProducts?.some(p => p?.productName?.includes('Programmatic Display Advertising'))
  const spotify = relatedProducts?.some(p => p?.productName?.includes('Spotify Advertising'))
  const microsoft = relatedProducts?.some(p => p?.productName?.includes('Microsoft Advertising'))
  const snapchat = relatedProducts?.some(p => p?.productName?.includes('SnapChat Advertising'))
  const youtube = relatedProducts?.some(p => p?.productName?.includes('Youtube Advertising'))
  const tiktok = relatedProducts?.some(p => p?.productName?.includes('TikTok Advertising'))
  const googleSearch = relatedProducts?.some(p => p?.productName?.includes('Paid Search Advertising'))
  const googleDisplay = relatedProducts?.some(p => p?.productName?.includes('Google Display Advertising'))
  const seo1 = relatedProducts?.some(p => p?.productName?.includes('SEO - Tier 1'))
  const seo2 = relatedProducts?.some(p => p?.productName?.includes('SEO - Tier 2'))
  const seo3 = relatedProducts?.some(p => p?.productName?.includes('SEO - Tier 3'))
  const seo4 = relatedProducts?.some(p => p?.productName?.includes('SEO - Tier 4'))
  const webHosting30 = relatedProducts?.some(p =>
    p?.productName?.includes('Website Hosting + 30 Minutes of Maintenance')
  )
  const webHosting60 = relatedProducts?.some(p =>
    p?.productName?.includes('Website Hosting + 60 Minutes of Maintenance')
  )
  const webHosting = relatedProducts?.some(p => p?.productName?.includes('Website Hosting'))
  const webRevisions = relatedProducts?.some(
    p => p?.productName?.includes('Website Revisions') || p?.productName?.includes('Website Revisions - Additional')
  )
  const webStandardBuild = relatedProducts?.some(p => p?.productName?.includes('Standard Website Build'))
  const webEcommerceBuild = relatedProducts?.some(p => p?.productName?.includes('E-Commerce Website Build'))
  const webPremiumBuild = relatedProducts?.some(p => p?.productName?.includes('Premium Website Build'))

  const droneVideoAdd = relatedProducts?.some(p => p?.productName?.includes('Drone Video - Add On'))
  const droneShootAdd = relatedProducts?.some(p => p?.productName?.includes('Drone Shoot - Add On'))
  const isVideoEdit = relatedProducts?.some(p => p?.productName?.includes('Video Editing'))
  const isLifestyleShoot = relatedProducts?.some(p => p?.productName?.includes('Lifestyle Video Shoot'))
  const isVideoShoot = relatedProducts?.some(p => p?.productName?.includes('Video Shoot'))
  const isDesignMaterials = relatedProducts?.some(p => p?.productName?.includes('Design Materials'))
  const isFullBrandBuild = relatedProducts?.some(p => p?.productName?.includes('Full Brand Build'))
  const isSystemsKit = relatedProducts?.some(p => p?.productName?.includes('Business Systems Kit'))
  const isBrandingGuide = relatedProducts?.some(p => p?.productName?.includes('Branding Guide'))
  const isPropertyNaming = relatedProducts?.some(p => p?.productName?.includes('Property Naming'))
  const isMarketingCollateral = relatedProducts?.some(p => p?.productName?.includes('Marketing Collateral'))
  const isLogoCreation = relatedProducts?.some(p => p?.productName?.includes('Graphic Design - Logo Creation'))
  const isAddtlLogoRevisions = relatedProducts?.some(p =>
    p?.productName?.includes('Graphic Design - Additional Logo Revisions')
  )
  const isRevisions = relatedProducts?.some(p => p?.productName?.includes('Graphic Design - Revisions'))
  const isGraphicDesignGeneral = relatedProducts?.some(p => p?.productName?.includes('Graphic Design - General'))
  const isTravelLodging = relatedProducts?.some(p => p?.productName?.includes('Travel, Lodging, Misc.'))
  const isStagingEquipment = relatedProducts?.some(p =>
    p?.productName?.includes('Product Photography Staging Equipment')
  )
  const isProjectedCreativeBudget = relatedProducts?.some(p => p?.productName?.includes('Projected Creative Budget'))
  const isTalentModels = relatedProducts?.some(p => p?.productName?.includes('Talent/Models'))
  const isPhotoShoot = relatedProducts?.some(p => p?.productName?.includes('Photo Shoot'))
  const isPhotoEdit = relatedProducts?.some(p => p?.productName?.includes('Photo Edit'))
  const isAddPage = relatedProducts?.some(p => p?.productName?.includes('Website Build - Additional Page Creation'))

  // Determine creative types based on the contract items.
  // Adjust these mappings as needed.
  const creativeTypes = []
  if (webHosting30 || webHosting60 || webHosting) {
    creativeTypes.push('hosting')
  }
  // Video-related
  else if (isVideoEdit || isVideoShoot || isLifestyleShoot || droneVideoAdd || droneShootAdd) {
    creativeTypes.push('video')
  }

  // Photography-related
  else if (isPhotoShoot || isPhotoEdit) {
    creativeTypes.push('photography')
  }

  // Graphic/Design related
  // if (isDesignMaterials || isBrandingGuide || isPropertyNaming || isMarketingCollateral) {
  //   // Depending on your desired granularity, you might break these out.
  //   creativeTypes.push('graphicDesign')
  // }
  else if (isFullBrandBuild || isSystemsKit) {
    creativeTypes.push('fullBrandBuild')
  }
  // Logo and branding
  else if (isLogoCreation || isAddtlLogoRevisions || isRevisions) {
    creativeTypes.push('design')
    // creativeTypes.push('logoDesign')
  }
  // Website related
  else if (webPremiumBuild || webStandardBuild || webEcommerceBuild || isAddPage) {
    creativeTypes.push('website')
    // creativeTypes.push('website')
    // creativeTypes.push('websiteDesignOverview')
    // creativeTypes.push('websiteStructure')
  } else if (
    isTravelLodging ||
    isStagingEquipment ||
    isProjectedCreativeBudget ||
    isTalentModels ||
    isDesignMaterials ||
    isBrandingGuide ||
    isPropertyNaming ||
    isMarketingCollateral
  ) {
    creativeTypes.push('miscCreative')
  } else {
    creativeTypes.push('miscCreative')
  }

  // Remove duplicate types
  const uniqueCreativeTypes = Array.from(new Set(creativeTypes))

  return {
    ...deal,
    isGoogleSearch: googleSearch,
    seoTier: seo1
      ? { label: 'Tier 1' }
      : seo2
      ? { label: 'Tier 2' }
      : seo3
      ? { label: 'Tier 3' }
      : seo4
      ? { label: 'Tier 4' }
      : '',
    isMetaAdvertising: meta,
    isGoogleDisplay: googleDisplay,
    isSimplifi: simplifi,
    isTikTok: tiktok,
    isSpotify: spotify,
    isLinkedIn: linkedIn,
    isMicrosoftAdvertising: microsoft,
    isSnapchat: snapchat,
    isYoutube: youtube,
    isSeo1: seo1,
    isSeo2: seo2,
    isSeo3: seo3,
    isSeo4: seo4,
    containsSEO: seo1 || seo2 || seo3 || seo4,
    isWebHosting: webHosting,
    isWebHosting30: webHosting30,
    isWebHosting60: webHosting60,
    hostingTier: webHosting
      ? { label: 'Hosting' }
      : webHosting30
      ? { label: 'Hosting 30' }
      : webHosting60
      ? { label: 'Hosting 60' }
      : '',
    isWebRevisions: webRevisions,
    buildTier: webStandardBuild
      ? { label: 'Standard' }
      : webEcommerceBuild
      ? { label: 'ECommerce' }
      : webPremiumBuild
      ? { label: 'Premium' }
      : '',
    isDroneVideoAdd: droneVideoAdd,
    isDroneShootAdd: droneShootAdd,
    isVideoEdit: isVideoEdit,
    isVideoShoot: isVideoShoot,
    isDesignMaterials: isDesignMaterials,
    isFullBrandBuild: isFullBrandBuild,
    isSystemsKit: isSystemsKit,
    isBrandingGuide: isBrandingGuide,
    isPropertyNaming: isPropertyNaming,
    isMarketingCollateral: isMarketingCollateral,
    isLogoCreation: isLogoCreation,
    isAddtlLogoRevisions: isAddtlLogoRevisions,
    isRevisions: isRevisions,
    isGraphicDesignGeneral: isGraphicDesignGeneral,
    isTravelLodging: isTravelLodging,
    isStagingEquipment: isStagingEquipment,
    isProjectedCreativeBudget: isProjectedCreativeBudget,
    isTalentModels: isTalentModels,
    isPhotoShoot: isPhotoShoot,
    isPhotoEdit: isPhotoEdit,
    isPremiumBuild: webPremiumBuild,
    isStandardBuild: webStandardBuild,
    isEcommerceBuild: webEcommerceBuild,
    isAddPage: isAddPage,
    isWebsiteBuild: webPremiumBuild || webStandardBuild || webEcommerceBuild,
    // Here we add our calculated creative types array:
    creativeType: uniqueCreativeTypes,
  } as OrganizationTableItem
}
